import React, { Component } from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { connect } from 'redaction'
import { array, constants } from 'common/helpers'
import cx from 'classnames'
import { FormattedHTMLMessage } from 'sb-react-intl'

import Modal from 'components/modal/Modal/Modal'
import CommonButton from 'components/buttons/CommonButton/CommonButton'
import ContentWithLoader from 'components/loaders/ContentWithLoader/ContentWithLoader'

import SkipButton from '../SkipButton/SkipButton'

import messages from './messages'
import s from './ReviewTagsModal.scss'


class ReviewTagsModal extends Component {

  static propTypes = {
    name: PropTypes.string,
  }

  static defaultProps = {
    name: constants.modals.review.ReviewTags,
  }

  state = {
    isFetching: false,
    currentStep: 1,
  }

  stepsCount = 0
  tagGroups = []

  get isFirstStep() {
    return this.state.currentStep === 1 // eslint-disable-line
  }

  get isLastStep() {
    return this.state.currentStep === this.stepsCount // eslint-disable-line
  }

  componentDidMount() {
    const { data: { productId } } = this.props

    this.startFetching()

    actions.models.review.fetchTags({ productId })
      .finally(this.stopFetching)
  }

  componentWillReceiveProps(props) {
    this.tagGroups = Object.keys(props.tags)
    this.stepsCount = this.tagGroups.length
  }

  setStep = (currentStep) => this.setState({ currentStep })

  nextStep = () => this.setStep(this.state.currentStep + 1) // eslint-disable-line
  prevStep = () => this.setStep(this.state.currentStep - 1) // eslint-disable-line

  stopFetching = () => this.setState({ isFetching: false })
  startFetching = () => this.setState({ isFetching: true })

  getTitle = () => {
    if (this.isFirstStep) {
      return messages.titleFirstStep
    }

    if (this.isLastStep) {
      return messages.titleLastStep
    }

    return messages[`title${this.state.currentStep}Step`]
  }

  close = () => {
    const { name, data: { onReviewTagsVoted } } = this.props

    if (typeof onReviewTagsVoted === 'function') {
      onReviewTagsVoted()
    }

    actions.models.modals.close(name)
  }

  navToList = () => {
    this.close()
    actions.models.modals.open(constants.modals.review.ReviewItemList)
  }

  navToRecommendations = () => {
    this.close()
    actions.models.modals.open(constants.modals.review.Recommendations)
  }

  handleTagClick = (tag) => {
    const { data: { productId, reviewId, withItemList } } = this.props

    actions.models.review.vote({ productId, tag, reviewId })

    if (this.isLastStep) {
      this.startFetching()

      actions.models.review.fetchItems(true)
        .then(
          (itemsCount) => {
            if (withItemList && Boolean(itemsCount)) {
              this.navToList()
            }
            else {
              this.navToRecommendations()
            }
          }
        )
        .finally(this.stopFetching)
    }
    else {
      this.nextStep()
    }
  }

  renderSteps() {
    const { currentStep } = this.state

    return (
      <div className={s.steps}>
        {
          array.range(1, this.stepsCount).map((index) => {
            const stepClassName = cx(s.step, {
              [s.active]: index === currentStep,
              [s.done]: index < currentStep,
            })

            return (
              <div key={index} className={stepClassName}>
                {index}
              </div>
            )
          })
        }
      </div>
    )
  }

  renderNote() {
    const { currentStep } = this.state

    let noteMessage = this.isFirstStep ? messages.noteFirstStep : messages.noteNextStep

    if (this.tagGroups[currentStep - 1] === 'Season') {
      noteMessage = messages.noteSeasonStep
    }

    return (
      <FormattedHTMLMessage className={s.desc} {...noteMessage} />
    )
  }

  renderButtons() {
    const { name } = this.props

    const skipButtonClassName = cx({
      [s.skipButton]: !this.isFirstStep,
    })

    return (
      <div className={s.buttons}>
        {
          !this.isFirstStep && (
            <CommonButton
              className={s.backButton}
              xlg
              back
              emptyGray
              onClick={this.prevStep}
            />
          )
        }
        <SkipButton modalName={name} className={skipButtonClassName} />
      </div>
    )
  }

  renderTags() {
    const { tags } = this.props
    const { currentStep } = this.state

    const tagGroup = tags[this.tagGroups[currentStep - 1]]

    return (
      <div className={s.tags}>
        {
          Boolean(tagGroup) && tagGroup.map(({ img, name }, index) => (
            <div
              key={index}
              className={s.tag}
              onClick={() => this.handleTagClick(name)}
            >
              <img
                className={s.tagImage}
                src={img}
                alt={`${name} tag`}
              />
              <div className={s.tagName}>{name}</div>
            </div>
          ))
        }
      </div>
    )
  }

  render() {
    const { isFetching } = this.state
    const { name } = this.props

    return (
      <Modal
        className={s.modal}
        name={name}
        title={this.getTitle()}
        onClose={this.close}
      >
        <div className={s.content}>
          <FormattedHTMLMessage className={s.desc} tag="div" {...messages.description} />
          <ContentWithLoader isFetching={isFetching}>
            {this.renderSteps()}
            {this.renderNote()}
            {this.renderTags()}
            {this.renderButtons()}
          </ContentWithLoader>
        </div>
      </Modal>
    )
  }
}


export default connect({
  tags: 'models.review.tags',
})(ReviewTagsModal)
